export const VOUCHER_TABLE_COLUMNS = [
  { name: "voucher_code", label: "Mã voucher" },
  { name: "month", label: "Tháng áp dụng" },
  // { name: "year", label: "Năm" },
  { name: "limit1", label: "Hạn mức 1" },
  { name: "ex_rate1", label: "Hệ số 1" },
  { name: "limit2", label: "Hạn mức 2" },
  { name: "ex_rate2", label: "Hệ số 2" },
  { name: "min_pay", label: "Mức thêm tối thiểu" },
  { name: "voucher_type", label: "Loại" },
  { name: "ref_rate", label: "Mức thưởng giới thiệu" },
  { name: "created_by", label: "Người thêm" },
  { name: "created_at", label: "Ngày thêm" },
];

export const VOUCHER_DELETED_COLUMNS = [
  { name: "voucher_code", label: "Mã voucher" },
  { name: "month", label: "Tháng áp dụng" },
  // { name: "year", label: "Năm" },
  { name: "limit1", label: "Hạn mức 1" },
  { name: "ex_rate1", label: "Hệ số 1" },
  { name: "limit2", label: "Hạn mức 2" },
  { name: "ex_rate2", label: "Hệ số 2" },
  { name: "min_pay", label: "Mức thêm tối thiểu" },
  { name: "created_by", label: "Người thêm" },
  { name: "deleted_at", label: "Ngày xóa" },
];

export const VOUCHER_HISTORY_TABLE_COLUMNS = [
  { name: "voucher_code", label: "Mã voucher" },
  { name: "transfer_amount", label: "Số tiền thêm" },
  { name: "applied_amount", label: "Sau khi áp dụng" },
  // { name: "nExtPoint1", label: "knb" },
  { name: "nExtPoint2", label: "knb khóa thêm" },
  { name: "user_id", label: "Người thêm" },
  { name: "created_at", label: "Ngày thêm" },
];

export const MINPAY_RATE = 1000000;

export const VOUCHER_DELETED_TYPES = [
  { value: false, label: "NOT" },
  { value: true, label: "DELETED" },
];

export const VOUCHER_TYPES = [
  { value: "PRIVATE", label: "PRIVATE" },
  { value: "GLOBAL", label: "GLOBAL" },
];
